import { render } from "./SaasSolution.vue?vue&type=template&id=33aa08f6&scoped=true"
import script from "./SaasSolution.vue?vue&type=script&lang=js"
export * from "./SaasSolution.vue?vue&type=script&lang=js"

import "./SaasSolution.vue?vue&type=style&index=0&id=33aa08f6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33aa08f6"]])

export default __exports__